export const PAGE_SIZE = 20;

export const ERROR_ICON_STYLE = { fontSize: 14, marginRight: 8, color: "#cf1322" };

export function normalizeKeyId(item, idx) {
  if (typeof item === "string") return item;
  return item?.key ?? item?.full_key ?? item?.id ?? `row-${idx}`;
}

export function normalizeValueText(item) {
  if (typeof item === "string") return "";
  // prefer explicit value fields, fallback to type or stringify
  const v = item?.value ?? item?.type ?? "";
  return typeof v === "string" ? v : JSON.stringify(v);
}

export function createPagination(displayedKeys = [], t) {
  if (!displayedKeys || displayedKeys.length <= 1) return false;

  return {
    size: "small",
    total: displayedKeys.length,
    showTotal: (total, range) =>
      displayedKeys.length > PAGE_SIZE
        ? (t("keysList.showing_keys", { from: range[0], to: range[1], total }) ||
            `Showing ${range[0]}–${range[1]} of ${total} keys`)
        : (t("keysList.showing_total_keys", { total }) || `Showing ${total} keys`),
    showSizeChanger: false,
    pageSize: PAGE_SIZE,
    showLessItems: true,
    align: "end",
  };
}